module.exports = __webpack_public_path__ + "img/ic_file-loading.d1c50e36.svg";